// extracted by mini-css-extract-plugin
module.exports = {"main":"DeleteConfirmationModal_main__3Y9UN","text":"DeleteConfirmationModal_text__1X00A","buttons_container":"DeleteConfirmationModal_buttons_container__3X2uh"};